export const langs: Record<string, string> = {
  RUS: 'RU',
  ENG: 'EN',
};
